<template>
	<div>
		<!-- <el-card class="box-card">
			<el-row :gutter="20">
				<el-col :span="12">总收入：
					<span style="color:#67C23A">{{total_in.rmb}}</span> (人民币)
					<span style="color:#67C23A;margin-left: 20px;">{{total_in.th}}</span> (泰铢)
					<span style="color:#67C23A;margin-left: 20px;">{{total_in.ph}}</span> (比索)
					<span style="color:#67C23A;margin-left: 20px;">{{total_in.id}}</span> (印尼卢比)
					<span style="color:#67C23A;margin-left: 20px;">{{total_in.vn}}</span> (越南盾)
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="12">总支出：
					<span style="color:#F56C6C">{{total_out.rmb}}</span> (人民币)
					<span style="color:#F56C6C;margin-left: 20px;">{{total_out.th}}</span> (泰铢)
					<span style="color:#F56C6C;margin-left: 20px;">{{total_out.ph}}</span> (比索)
					<span style="color:#F56C6C;margin-left: 20px;">{{total_out.id}}</span> (印尼卢比)
					<span style="color:#F56C6C;margin-left: 20px;">{{total_out.vn}}</span> (越南盾)
				</el-col>
			</el-row>
		</el-card> -->
		<el-card class="box-card">
			<el-form :inline="true">
				<el-form-item v-if="role_body == 'admin' || role_body == 'hhr'" label="用户">
					<el-select style="width: 150px;" v-model="listQuery.search.uid" filterable clearable placeholder="请选择">
						<el-option v-for="item in user_all" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="role_body == 'admin' || role_body == 'hhr'" label="合作商">
					<el-select style="width: 150px;" v-model="listQuery.search.kh_uid" clearable placeholder="全部">
						<el-option v-for="item in kh_all" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="分组">
					<el-select v-model="listQuery.search.group" clearable placeholder="全部">
						<el-option v-for="item in group_list" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="店铺名">
					<el-input placeholder="请填写" v-model="listQuery.search.shop_name" clearable> </el-input>
				</el-form-item>
				<!-- <el-form-item label="任务订单ID">
					<el-input placeholder="请填写" v-model="listQuery.search.order_id" clearable> </el-input>
				</el-form-item> -->
				<el-form-item label="订单号:">
					<el-input placeholder="请填写" v-model="listQuery.search.order_number" clearable> </el-input>
				</el-form-item>
				<el-form-item label="订单状态">
					<el-select style="width: 120px;" v-model="listQuery.search.state" clearable
						placeholder="请选择">
						<el-option v-for="item in state_all" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="币种">
					<el-select style="width: 120px;" v-model="listQuery.search.currency_type" clearable placeholder="全部">
						<el-option v-for="item in currency" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="role_body == 'admin' || role_body == 'hhr'" label="类型">
					<el-select v-model="listQuery.search.type" clearable placeholder="全部">
						<el-option v-for="item in br_type" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="交易类型">
					<el-select style="width: 120px;" v-model="listQuery.search.sign" clearable placeholder="全部">
						<el-option label="支出" value="0"></el-option>
						<el-option label="收入" value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="日期">
					<el-date-picker v-model="listQuery.search.start_time" type="date" placeholder="开始日期">
					</el-date-picker>
					-
					<el-date-picker v-model="listQuery.search.end_time" type="date" placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
			</el-form>
			<el-button type="primary" @click="keySearch"><i class="el-icon-search"></i> 搜索</el-button>
			<el-button type="primary" style="margin-left:50px;" plain @click="resetSearch"><i
					class="el-icon-search"></i>
				重置搜索</el-button>
			<el-button type="success" style="margin-left:180px;" plain @click="excel"><i class="el-icon-download"></i>
				导出数据</el-button>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column prop="id" label="ID"></el-table-column>
				<el-table-column prop="uid" label="用户(ID)">
					<template slot-scope="{row}">
						<span>{{row.uid_name}} ({{row.uid}})</span>
					</template>
				</el-table-column>
				<el-table-column v-if="role_body == 'admin' || role_body == 'hhr'" prop="uid" label="合作商(ID)">
					<template slot-scope="{row}">
						<span v-if="row.kh_uid">{{row.kh_name}} ({{row.kh_uid}})</span>
					</template>
				</el-table-column>
				<el-table-column prop="group_init" label="分组"></el-table-column>
				<el-table-column prop="shop_name" label="店铺名"></el-table-column>
				<el-table-column prop="create_time" label="日期" width="150">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="type_init" label="类型"> </el-table-column>
				<el-table-column prop="currency_type_init" label="币种"> </el-table-column>
				<el-table-column prop="money" label="金额">
					<template slot-scope="{row}">
						<span v-if="row.sign == 1" style="color:#67C23A">+ {{row.money}}</span>
						<span v-else style="color:#F56C6C">- {{row.money}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="balance" label="账户余额"> </el-table-column>
				<el-table-column prop="remarks" label="备注"> </el-table-column>
				<!-- <el-table-column prop="order_id" label="任务订单ID"> </el-table-column> -->
				<el-table-column prop="order_number" label="订单号"> </el-table-column>
				<el-table-column prop="order_state" label="订单状态"> </el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
		</div>
	</div>
</template>

<script>
	import {
		getToken,
	} from '@/tool/cookie'
	import {
		brListInit,
		brList,
		excelToken
	} from '@/api/sign_admin'
	import request from '@/tool/request'
	import {
		parseTime,getBaseUrl
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import Dtp from '@/components/Ele/dateTimePicker.vue' // 时间选择组件
	export default {
		components: {
			Pagination,
			Dtp
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
				total_in: {
					rmb: '0.00',
					th: '0.00',
					ph: '0.00'
				},
				total_out: {
					rmb: '0.00',
					th: '0.00',
					ph: '0.00'
				},
				currency: [], // 所有币种
				br_type: [], // 所有类型
				is_show_search: false,
				store_all: [], // 所有店铺
				role_body: '',
				kh_all: [],
				group_list:[], // 所有分组
				user_all:[], // 所有用户
				state_all:[], // 所有订单状态
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},
			resetSearch() { // 重置搜索
				this.resetSearchData()
				this.getList()
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						sign: '',
						start_time: '',
						end_time: '',
						currency_type: '',
						type: '',
					},
				}
			},
			getList() { // 获取列表数据
				this.loading = true;
				brList(Qs.stringify(this.listQuery)).then(response => {
					let r = response.result;
					this.data_list = r.items;
					this.total = r.total;

					if (this.listQuery.page == 1) {
						// this.total_in = {
						// 	rmb:r.total_in.rmb,
						// 	th:r.total_in.th,
						// 	ph:r.total_in.ph,
						// 	id:r.total_in.id,
						// 	vn:r.total_in.vn,
						// };
						// this.total_out = {
						// 	rmb:r.total_out.rmb,
						// 	th:r.total_out.th,
						// 	ph:r.total_out.ph,
						// 	id:r.total_out.id,
						// 	vn:r.total_out.vn,
						// };

						this.currency = r.currency;
						this.br_type = r.br_type;
						this.store_all = r.store_all;
						this.role_body = r.role_body;
						this.kh_all = r.kh_all;
						this.group_list = r.group_list;
						this.user_all = r.user_all;
						this.state_all = r.state_all;
					}

					this.loading = false;
				})
			},
			excel() {
				// 获取exceltoken
				excelToken(Qs.stringify()).then(response => {
					let token = response.result.token;
					if (token) {
						let search = JSON.stringify(this.listQuery.search);
						let login_uid = getToken('login_uid');
						window.open(getBaseUrl() + "/SignExcel/signBrList?uid=" + login_uid +
							"&token=" + token + '&search=' + search,
							"_blank");
					}
				})
			},
		}
	}
</script>
<style>
	.el-radio {
		margin-right: 0px;
	}
</style>
